/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = BRAKES
 *
 * 1 = EMISSION
 *
 * 2 = GOVERNMENT
 *
 * 3 = TACHO
 */
export enum VehicleInspectionType {
  BRAKES = 0,
  EMISSION = 1,
  GOVERNMENT = 2,
  TACHO = 3,
}
